import { ActionHeader, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { v4 as uuidv4 } from "uuid";
import { set } from "lodash";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const AppointmentLogDetails = () => {
  const [appointmentLogForm] = Form.useForm();
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();

  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [tempTableList, setTempTableList] = useState([]);
  const [appoinmentLogId, setAppoinmentLogId] = useState(null);
  const [selectedRow, setSelectedRow] = useState();
  const [showAppointmentLog, setShowAppointmentLog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const clickAppointmentLog = (val) => {
    setShowAppointmentLog(true);
    if (val == "edit") {
      setIsEdit(true);
    }
  };

  const headers = [
    { key: "dateSeenBy", text: "Date Seen" },
    { key: "timeSeenBy", text: "Time Seen" },
    { key: "appointmentOfficerStaff", text: "Appointment Officer" },
    { key: "reasonForAppt", text: "Reason for Appointment" },
    { key: "typeOfAppointment", text: "Type of Appointment" },
    { key: "notes", text: "Notes" },
  ];

  useEffect(() => {
    if (bookings?.appointmentLog?.length > 0) {
      setTempTableList(
        bookings?.appointmentLog.map((item) => {
          console.log(
            item,
            getOptionsFromRefList("", true).filter(
              (staff) => staff.value === item.appointmentOfficerStaffID
            )
          );
          return {
            ...item,
            appointmentOfficerStaff: getOptionsFromRefList("", true).filter(
              (staff) =>
                staff.value === parseInt(item.appointmentOfficerStaffID)
            )?.[0]?.label,
          };
        })
      );
    } else {
      setTempTableList([]);
    }
  }, [bookings]);

  useEffect(() => {
    canActivateHide();
  }, [bookingsFieldsEnabled]);

  useEffect(() => {
    appointmentLogForm.setFieldsValue(selectedRow);
  }, [selectedRow]);

  const canActivateHide = () => {
    setAppoinmentLogId(null);
    setIsRowSelected(false);
    setSelectedRow(null);
    setShowAppointmentLog(false);
    setIsEdit(false);
  };

  const patchSelectedRow = (selectedRow) => {
    setSelectedRow({
      dateTimeSeenBy: isNonEmptyVariable(selectedRow?.dateSeenBy)
        ? dayjs(
            `${selectedRow?.dateSeenBy || ""} ${selectedRow?.timeSeenBy || ""}`
          )
        : null,
      appointmentOfficerStaffID: selectedRow?.appointmentOfficerStaffID,
      reasonForAppt: selectedRow?.reasonForAppt,
      typeOfAppointment: selectedRow?.typeOfAppointment,
      notes: selectedRow?.notes,
    });
    setAppoinmentLogId(selectedRow?.appointmentLogID || selectedRow?.id);
    setIsRowSelected(true);
  };

  const saveAptLog = () => {
    appointmentLogForm
      .validateFields()
      .then((values) => {
        values.dateTimeSeenBy = isNonEmptyVariable(values?.dateTimeSeenBy)
          ? dayjs(values?.dateTimeSeenBy).format("MM/DD/YYYY HH:mm")
          : null;

        values.dateSeenBy = values?.dateTimeSeenBy?.split(" ")[0];
        values.timeSeenBy = values?.dateTimeSeenBy?.split(" ")[1];

        delete values?.dateTimeSeenBy;
        if (appoinmentLogId) {
          let data = [...tempTableList];
          data = data?.map((p) =>
            p?.appointmentLogID === appoinmentLogId || p?.id === appoinmentLogId
              ? { ...p, ...values }
              : p
          );
          updateReleaseNotes(data);
        } else {
          const newData = {
            ...values,
            id: uuidv4(),
          };
          const data = [...tempTableList, newData];
          updateReleaseNotes(data);
        }
        setShowAppointmentLog(false);
      })
      .catch((err) => console.log(err));
  };

  const addLog = () => {
    appointmentLogForm.setFieldsValue({
      dateTimeSeenBy: new Date() ? dayjs(new Date()) : null,
      appointmentOfficerStaffID: currentUser.staffId,
      reasonForAppt: null,
      typeOfAppointment: null,
      notes: null,
    });
    setAppoinmentLogId(null);
    setShowAppointmentLog(true);
  };

  const deleteAppointmentLog = () => {
    const tempArray = [...tempTableList];
    const deleteIndex =
      tempArray?.length > 1
        ? tempArray?.findIndex(
            (item) =>
              item?.appointmentLogID === appoinmentLogId ||
              item?.id === appoinmentLogId
          )
        : 0;
    tempArray.splice(deleteIndex, 1);
    updateReleaseNotes(tempArray);

    const url = API_ENDPOINTS.appoinmentLog + "/id/" + appoinmentLogId;
    dispatch(setDeleteAPis(url));
    setAppoinmentLogId(null);
    setIsRowSelected(false);
    setSelectedRow(null);
  };

  const updateReleaseNotes = (tb) => {
    dispatch(
      setBookings({
        appointmentLog: [...tb],
      })
    );
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Inmate_Medical
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol>
          <Button
            onClick={addLog}
            disabled={
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.ADD,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Medical
              )
            }
          >
            ADD
          </Button>
        </StyledGridCol>
        <StyledGridCol>
          <Button
            style={{ marginRight: "10px" }}
            disabled={
              !isRowSelected ||
              tempTableList?.length === 0 ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.VIEW,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Medical
              )
            }
            onClick={() => clickAppointmentLog("edit")}
          >
            Details
          </Button>

          <Popconfirm
            title="Delete the Appointment Log"
            description="Are you sure to delete this Appointment log?"
            onConfirm={deleteAppointmentLog}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button
              color="primary"
              type="primary"
              style={{ marginLeft: "10px" }}
              disabled={
                !isRowSelected ||
                tempTableList?.length === 0 ||
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.DELETE,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical
                )
              }
            >
              Delete
            </Button>
          </Popconfirm>
        </StyledGridCol>
      </StyledGridRow>

      <Modal
        header={"Appointment Log"}
        show={showAppointmentLog}
        size="xl"
        onHide={canActivateHide}
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: saveAptLog,
            disabled: isDisabled || !bookingsFieldsEnabled,
          },
        ]}
        footerCloseAction={() => setIsEdit(false)}
        footerCloseActionText={"Close"}
      >
        <Form form={appointmentLogForm} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={6}>
              <FormItem label="Date Seen" name="dateTimeSeenBy">
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  showTime={true}
                  format="MM/DD/YYYY hh:mm"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={4}>
              <FormItem label="Seen By" name="appointmentOfficerStaffID">
                <Select
                  options={getOptionsFromRefList("", true)}
                  placeholder="Seen By"
                  showSearch={true}
                  variant="outlined"
                  onChange={(e) => {
                    setTimeout(() => document.activeElement.blur(), 0);
                  }}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={6}>
              <FormItem label="Reason for Appointment" name="reasonForAppt">
                <Select
                  options={getOptionsFromRefList("Reason_for_Appt")}
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                  // onChange={(e) => {
                  //     setTimeout(() => document.activeElement.blur(), 0)
                  // }}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem label="Type of Appointment" name="typeOfAppointment">
                <Select
                  options={getOptionsFromRefList("Type_of_Appointment")}
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                  // onChange={(e) => {
                  //   setTimeout(() => document.activeElement.blur(), 0)
                  // }}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={12}>
              <FormItem label="Additional Notes" name="notes">
                <TextField
                  inputType="textarea"
                  as="textarea"
                  id="description"
                  name="description"
                  variant="outlined"
                  rows="5"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Inmate_Medical
      ) && (
        <Table
          headers={headers}
          data={tempTableList}
          style={{ marginTop: "15px" }}
          onRowClick={(data) => patchSelectedRow(data)}
          onRowDoubleClick={(value) => {
            patchSelectedRow(value);
            clickAppointmentLog("edit");
          }}
          selected={selectedRow === null}
        />
      )}
    </>
  );
};
export default AppointmentLogDetails;
